import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AuthService {
  constructor() {
    this.endpoints = createPrefix('/auth', {
      auth: '/auth',
      refresh: '/refresh',
      password: [
        '/password',
        {
          reset: '/reset',
          confirm: '/reset/confirm',
        },
      ],
    })
  }

  static create() {
    return new AuthService()
  }

  isTokenRefreshUrl(url) {
    return url.endsWith(this.endpoints.refresh())
  }

  async login(email, password) {
    const servicePath = this.endpoints.auth()
    const { data } = await axios.post(servicePath, { email, password })
    return data
  }

  async logOut() {
    const servicePath = this.endpoints.auth()
    await axios.delete(servicePath)
  }

  async refreshToken(token) {
    const servicePath = this.endpoints.refresh()
    const { data } = await axios.post(servicePath, token)
    return data
  }

  async resetPassword(email, options = {}) {
    const servicePath = this.endpoints.password.reset()
    const config = options.skipErrorToaster ? { skipErrorToaster: true } : {}
    const { data } = await axios.post(servicePath, { email }, config)
    return data
  }

  async confirmPassword(token, email, newPassword) {
    const servicePath = this.endpoints.password.confirm()
    const { data } = await axios.post(servicePath, {
      token,
      email,
      newPassword,
    })
    return data
  }
}
